import { Plugins, Capacitor } from "@capacitor/core";
import { FCM } from "capacitor-fcm";

import {ADD_NOTIFICATION, PUSH_NOTIFICATION_RECEIVED} from "../constants/actionTypes";
import { getMessagesFor, getSeniorId, addMessages } from "../../rocketChat/actions/rocketChatAction"
import { history } from "../../../../app";
import { formatRoute } from "react-router-named-routes";
import { ROUTER_MESSAGE_SENIOR } from "../../../constants/routers";
import { hash } from "../../../actions";
import store from "../../../../store";

let NotificationSystem = null;

try {
  Plugins.PushNotifications.register();
  Plugins.PushNotifications.addListener("pushNotificationActionPerformed", async ({ notification }) => {
    const seniorHash = hash(getSeniorId(notification.data.username));
    const route = formatRoute(ROUTER_MESSAGE_SENIOR, { seniorHash });

    store.dispatch({ type: PUSH_NOTIFICATION_RECEIVED, payload: notification.data });
    if (route !== history.location.pathname) {
      history.push(route);
    }

    const { messages } = await getMessagesFor(notification.data.username);

    store.dispatch(addMessages(messages));
  });

  Plugins.PushNotifications.createChannel({
    id: 'messages',
    name: __('Messages'),
    importance: 4
  });
}
catch(e) {
  console.error('Error setting up push notifications', e);
}

/**
 * Sets up
 * @param {object} notificationSystem notification system
 * @return {void}
 */
export function setup(notificationSystem) {
  NotificationSystem = notificationSystem;
}

/**
 * Adds a notification
 * @param {string} message - notification message
 * @param {string} level - notification level
 * @returns {Function} thunk
 */
export function addNotification(message, level) {
  return (dispatch) => {
    NotificationSystem.addNotification({
      message: message,
      level: level,
      position: "tc"
    });
    dispatch({ type: ADD_NOTIFICATION });
  };
}

/**
 * Sets up
 * @param {object} user - the user that should receive notifications
 * @return {void}
 */
export function subscribeToTopic(user) {
  if (Capacitor.isNative) {
    const fcm = new FCM();

    fcm.subscribeTo({ topic: `customer_${user.cust_id}` });
  }
}

/**
 * Unsubscribe from topic
 * @param {object} user - the user that should stop receiving notifications
 * @return {void}
 */
export function unsubscribeFromTopic(user) {
  if (Capacitor.isNative) {
    const fcm = new FCM();

    fcm.unsubscribeFrom({ topic: `customer_${user.cust_id}` });
  }
}